import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'distance',
})
export class DistancePipe implements PipeTransform {
    transform(value: number): string {
        if (value === null || value === undefined) {
            return '';
        }
        if (value >= 1000) {
            return `${Math.round(value / 100) / 10} km`;
        }
        return `${Math.round(value)} m`;
    }
}
